module.exports = __webpack_public_path__ + "static/media/hbt_boards.48d9f137.png";